var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',_vm._b({staticClass:"w-full rounded-2xl p-1"},'el-card',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }